import { render } from "./TinyEditor.vue?vue&type=template&id=15e894b6&scoped=true"
import script from "./TinyEditor.vue?vue&type=script&lang=js"
export * from "./TinyEditor.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-15e894b6"

export default script